<template>
  <div id="app" class="home_page">
    <HeaderComponent />
    <UserGuideComponent />
    <FooterComponents class="m-t-200"/>
  </div>
</template>

<script>
import UserGuideComponent from '@/components/UserGuide.vue'
import FooterComponents from '@/components/FooterComponents.vue'
import HeaderComponent from '@/components/HeaderComponent'

export default {
  name: 'UserGuideView',
  data () {
    return {
    }
  },
  components: {
    HeaderComponent,
    UserGuideComponent,
    FooterComponents
  }
}
</script>

<style>
</style>
